// src/components/store/CartHeaderButton.tsx
"use client";

import { useState, useEffect } from "react";
import { ShoppingCart } from "lucide-react";
import { useParams } from "next/navigation";
import { useCart } from "@/context/CartContext";

export default function CartHeaderButton() {
  const params = useParams();
  const subdomain = (params?.subdomain as string) || "nextlook";

  let contextTotal = 0;
  let contextOpenCart: (() => void) | null = null;
  let isContextAvailable = false;

  try {
    const cartCtx = useCart();
    contextTotal = cartCtx.totalItems || 0;
    contextOpenCart = cartCtx.openCart;
    isContextAvailable = true;
  } catch {
    isContextAvailable = false;
  }

  // 🌟 Default count strictly 0
  const [itemCount, setItemCount] = useState<number>(0);

  useEffect(() => {
    const updateCount = () => {
      // 1. Jodi CartContext thake, direct context theke count nibe
      if (isContextAvailable) {
        setItemCount(contextTotal);
        return;
      }

      // 2. Context na thakle shudhu active tenant-er specific cart key check korbe
      try {
        const raw = localStorage.getItem(`xylo_cart_${subdomain}`);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed) && parsed.length > 0) {
            const total = parsed.reduce(
              (sum: number, it: any) => sum + (Number(it.quantity) || 1),
              0
            );
            setItemCount(total);
            return;
          }
        }
      } catch {}

      // Kono item na thakle default 0
      setItemCount(0);
    };

    updateCount();

    window.addEventListener("cartUpdated", updateCount);
    window.addEventListener("addToCart", updateCount);
    window.addEventListener("storage", updateCount);

    return () => {
      window.removeEventListener("cartUpdated", updateCount);
      window.removeEventListener("addToCart", updateCount);
      window.removeEventListener("storage", updateCount);
    };
  }, [contextTotal, isContextAvailable, subdomain]);

  // Cart Drawer open kora
  const handleClick = () => {
    if (contextOpenCart) {
      contextOpenCart();
    }
    window.dispatchEvent(new CustomEvent("openCartDrawer"));
    window.dispatchEvent(new CustomEvent("openCart"));
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="View Shopping Cart"
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-slate-200 bg-white hover:bg-slate-50 text-slate-800 transition-all hover:scale-105 active:scale-95 cursor-pointer shadow-xs select-none"
    >
      <ShoppingCart className="w-4 h-4 text-emerald-600 shrink-0" />
      <span className="text-xs font-black tracking-tight">Cart</span>
      <span className="min-w-[20px] h-5 px-1.5 rounded-full bg-amber-500 text-white font-mono font-black text-[11px] flex items-center justify-center shadow-xs">
        {itemCount}
      </span>
    </button>
  );
}